import { useEffect, useState } from 'react';
import useFeatureFlags from './useFeatureFlags';

export const useHackReRenderForFeatureFlags = () => {
    const { loadingFlags, flags } = useFeatureFlags();
    const [key, setKey] = useState(0);

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (loadingFlags || Object.keys(flags).length < 1) {
                setKey(key + 1);
            } else {
                clearInterval(intervalId);
            }
        }, 500);

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    });

    return key;
};
